import { merge } from 'ramda';

import {
  SUCCESS,
  FAIL,
  REQUEST,
  SET_TV_JOBS_FILTER
} from 'src/store/actions/tvJobsActions';

const initialState = {
  list: [],
  filter: {},
  error: '',
  fetching: false
};

const tvJobsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST:
      return merge(state, { fetching: true });
    case SUCCESS:
      return merge(state, { list: action.jobs, fetching: false });
    case FAIL:
      return merge(state, { errors: action.error, fetching: false });
    case SET_TV_JOBS_FILTER:
      return merge(state, { filter: action.filter });
    default:
      return state;
  }
};

export default tvJobsReducer;
